import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 3,
    type: CHECKLIST_ITEM_TYPE.BOOK_APPOINTMENT,
    manifestKey: 'BOOK_APPOINTMENT',

    try_it: {
        button_label: 'Open Appointment Booker',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'BookAppointmentCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { appointment_id: 'demo-appt-001', datetime: '2026-06-01T10:00:00Z' },
        },
    },
    pre_flight_diff: [
        'Appointment booking dialog opens (separate from cell complete POST)',
        'Lead status: NEW → CONSULTATION_BOOKED (via appointment booking endpoint)',
        'Checklist item: PENDING → YES',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
        '⚠ Past-datetime risk: if appointment datetime is in the past, Dentally/cron may auto-mark as ATTENDED',
    ],
    has_step2_throttle: true,
    validation_laboratory: null,
};
